import React, { useState } from "react";
import "./style.scss";

export default function ContactPage() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: ""
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Hook this to your API / email service later
        console.log(form);
        alert("Thanks for reaching out! We’ll get back to you soon.");
        setForm({ name: "", email: "", message: "" });
    };

    return (
        <div className="contact-page">
            <div className="contact-header">
                <h1>Contact Us</h1>
                <p>
                    Have a question, feedback, or want to onboard your spot?
                    We'd love to hear from you.
                </p>
            </div>

            <div className="contact-content">
                <form className="contact-form" onSubmit={handleSubmit}>
                    <label>
                        Full Name
                        <input
                            type="text"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Email Address
                        <input
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <label>
                        Message
                        <textarea
                            name="message"
                            rows="5"
                            value={form.message}
                            onChange={handleChange}
                            required
                        />
                    </label>

                    <button type="submit">Send Message</button>
                </form>

                <div className="contact-info">
                    <h3>Get in Touch</h3>
                    <p>
                        Email: <a href="mailto:info@jamlyf.com">info@jamlyf.com</a>
                    </p>
                    <p>
                        For partnerships, demos, or onboarding your venue,
                        send us a message and our team will respond.
                    </p>
                </div>
            </div>
        </div>
    );
}
